import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./core/auth-context";
import Layout from "./components/Layout";
import RequireAuth from "./components/RequireAuth";
import HomeScreen from "./screens/HomeScreen";
import StoryScreen from "./screens/StoryScreen";
import AuthScreen from "./screens/AuthScreen";
import SubmitScreen from "./screens/SubmitScreen";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/story/:storyId" element={<StoryScreen />} />
            <Route path="/login" element={<AuthScreen mode="signin" />} />
            <Route
              path="/register"
              element={<AuthScreen mode="register" />}
            />
            <Route
              path="/submit"
              element={
                <RequireAuth>
                  <SubmitScreen />
                </RequireAuth>
              }
            />
            <Route
              path="*"
              element={
                <div className="text-center py-20">
                  <h1 className="font-display text-4xl text-white">
                    404
                  </h1>
                  <p className="text-ink-400 mt-3">
                    That page slipped into the dark.
                  </p>
                </div>
              }
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
